/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-02-21T13:42:12-08:00
*/

import UserItem from '../pages/Search/UserItem';
import SimpleUserItem from '../pages/Search/SimpleUserItem';
import React from 'react'

export default (userItemType) => (data) => {
  switch (userItemType) {
    case 'simple':
      return <SimpleUserItem {...data} />
    default:
      return <UserItem {...data} />
  }
}



// WEBPACK FOOTER //
// ./src/components/common/userItemFactory.js